export default __webpack_public_path__ + "static/media/story_img_case4.f2a0e544.jpg";